import { MarkObj } from 'rc-slider/lib/Marks'
import { CSSProperties } from 'react'

export const getSliderMarks = (
  labels: string[],
  style: CSSProperties,
): Record<string | number, React.ReactNode | MarkObj> => {
  const hasPresets = labels.length > 2
  const baseStyle: CSSProperties = {
    ...style,
    marginTop: 10,
    color: 'white',
    maxWidth: '4rem',
  }

  if (hasPresets) {
    return labels.reduce<Record<string | number, React.ReactNode | MarkObj>>(
      (accumulator, label, index) => {
        accumulator[index] = {
          style: baseStyle,
          label,
        }

        return accumulator
      },
      {},
    )
  } else {
    return {
      0: {
        style: baseStyle,
        label: labels[0],
      },
      100: {
        style: baseStyle,
        label: labels[1],
      },
    }
  }
}
